import Moment from "moment";

// 배송추적 링크 택배사 판별
//  - 택배사(delivery_company)가 기록된 일반주문: 해당 택배사 기준 (2026-10-01부터 롯데택배)
//  - 택배사 정보가 없는 주문(정기주문 등): 기존 기준 유지 (처리일 2025-08-01부터 CJ대한통운, 이전은 롯데택배)
export const isCjDelivery = (item) => {
    if (item && item.delivery_company) {
        return item.delivery_company !== "롯데택배";
    }
    return Moment(item && item.treat_date).format('YYYY-MM-DD') > '2025-07-31';
};
